export const EXTRA_NAMES = {
    SMS_CONFIRMATION: 'smsConfirmation',
    CAN_SEND_MONEY_BY_CARD_FROM_OTHER_COUNTRY: 'canSendMoneyByCardFromOtherCountry',
    SHOW_DISCLAIMER: 'showDisclaimer',
    SHOW_HUAWEI_DISCLAIMER: 'showHuaweiDisclaimer',
    CAN_SEND_MONEY: 'canSendMoney',
    SHOW_CHOOSE: 'showChoose',
    SHOW_WAITING_LIST_DISCLAIMER: 'showWaitingListDisclaimer',
    SHOW_FROZEN_DISCLAIMER: 'showFrozenDisclaimer',
    RESTORE_PASSWORD: 'restorePassword',
    AUTH_TYPE: 'authType',
    CAN_SEND_MONEY_BY_CARD_FROM_USER_COUNTRY: 'canSendMoneyByCardFromUserCountry',
    IS_NEW_USER: 'isNewUser',
    CHEQUE: 'cheque',
    SHOW_MODAL_TERMS_UPDATE_BLOCK: 'show_modal_terms_update_block',
    SHOW_MODAL_PROFILE_UPDATE_BLOCK: 'show_modal_profile_update_block',
    SHOW_MODAL_UNCONFIRMED_TRANSACTION_BLOCK: 'show_modal_unconfirmed_transaction',
    SHOW_MODAL_KYC_INCREASE_LIMIT_BLOCK: 'show_modal_kyc_increase_limit',
    SHOW_FORMAT_MESSAGE: 'showFormatMessage',
    SHOW_NOT_FOUND_MESSAGE: 'showNotFoundMessage',
    DEEP_LINK_PAYMENT_ID: 'deeplink_payment_id',
    SHOW_MODAL_KYC_INVALID_BLOCK: 'show_modal_kyc_invalid_block',
    SHOW_MASTERCARD_PROMO_MODAL: 'show_mastercard_promo_modal',
    POST_COUNTRY_SELECT_DISCLAIMER: 'postCountrySelectDisclaimer',
    BONUS_BANNER: 'bonusBanner',
    STRAPI_API: 'strapiApi',
    NO_AUTH_STRAPI_MENU: 'noAuthMenu',
    NEW_NO_AUTH_STRAPI_MENU: 'newNoAuthMenu',
    NO_AUTH_STRAPI_FOOTER: 'noAuthFooter',
    RECALCULATE: 'recalculate',
    COMMISSION: 'commission',
    DC_SOURCES: 'dcSources',
    SOURCES_FROM: 'sourcesFrom',
    SOURCES_TO_BANK_CARD: 'sourcesToBankCard',
    DOWNLOAD_BUTTONS: 'downloadButtons',
    NEED_TO_SIGN_MY_ID_TERMS: 'needToSignMyIdTerms',
    IS_MOBILE: 'isMobile',
    IS_NEW_LANDING: 'isNewLanding',
    ZENDESK_HELP_DATA: 'zendeskHelpData',
    NEED_TO_SIGN_LULU_TERMS: 'needToSignLuluTerms',
    USER_COUNTRY: 'userCountry',
    INCOMPLETE_TRANSFER: 'incompleteTransfer',
    PAYMENT_CATEGORY: 'paymentCategory',
    SHOW_CARD_ERROR_POPUP: 'showCardErrorPopUp',
    QUESTIONNAIRE: 'questionnaire',
    QUESTIONNAIRE_DISCLAIMER: 'questionnaireDisclaimer',
    USE_QUESTIONNAIRE_SCREEN: 'useQuestionnaireScreen',
} as const;

export type ExtraNameKey = keyof typeof EXTRA_NAMES;
export type ExtraNameValue = (typeof EXTRA_NAMES)[ExtraNameKey];

export const {
    SMS_CONFIRMATION,
    CAN_SEND_MONEY_BY_CARD_FROM_OTHER_COUNTRY,
    SHOW_DISCLAIMER,
    SHOW_HUAWEI_DISCLAIMER,
    CAN_SEND_MONEY,
    SHOW_CHOOSE,
    SHOW_WAITING_LIST_DISCLAIMER,
    SHOW_FROZEN_DISCLAIMER,
    RESTORE_PASSWORD,
    AUTH_TYPE,
    CAN_SEND_MONEY_BY_CARD_FROM_USER_COUNTRY,
    IS_NEW_USER,
    CHEQUE,
    SHOW_MODAL_TERMS_UPDATE_BLOCK,
    SHOW_MODAL_PROFILE_UPDATE_BLOCK,
    SHOW_MODAL_UNCONFIRMED_TRANSACTION_BLOCK,
    SHOW_MODAL_KYC_INCREASE_LIMIT_BLOCK,
    SHOW_FORMAT_MESSAGE,
    SHOW_NOT_FOUND_MESSAGE,
    DEEP_LINK_PAYMENT_ID,
    SHOW_MODAL_KYC_INVALID_BLOCK,
    SHOW_MASTERCARD_PROMO_MODAL,
    POST_COUNTRY_SELECT_DISCLAIMER,
    BONUS_BANNER,
    STRAPI_API,
    NO_AUTH_STRAPI_MENU,
    NEW_NO_AUTH_STRAPI_MENU,
    NO_AUTH_STRAPI_FOOTER,
    RECALCULATE,
    COMMISSION,
    DC_SOURCES,
    SOURCES_FROM,
    SOURCES_TO_BANK_CARD,
    DOWNLOAD_BUTTONS,
    NEED_TO_SIGN_MY_ID_TERMS,
    IS_MOBILE,
    IS_NEW_LANDING,
    ZENDESK_HELP_DATA,
    NEED_TO_SIGN_LULU_TERMS,
    USER_COUNTRY,
    INCOMPLETE_TRANSFER,
    PAYMENT_CATEGORY,
    SHOW_CARD_ERROR_POPUP,
    QUESTIONNAIRE,
    QUESTIONNAIRE_DISCLAIMER,
    USE_QUESTIONNAIRE_SCREEN,
} = EXTRA_NAMES;
